import { MELHOR_ENVIO_AUTH_URL } from 'settings';

export const redirectToMelhorEnvioAuth = (callback: () => void) => {
  window.open(MELHOR_ENVIO_AUTH_URL, 'melhorEnvioPopupWindow', 'status = 1, height = 666, width = 666, resizable = 0');
  (window as any).handleCloseMelhorEnvioPopup = callback;
};

export const deepClone = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};
